// The chart SVGs come from the admin API's renderer (charts.Scene.SVG),
// which only emits these elements and attributes and escapes all text.
// As defence in depth they are rebuilt from an allow-list before they are
// shown, so nothing else (scripts, handlers, links, foreign content) can
// reach the page even if the renderer had a bug.
const ELEMENTS = new Set(['svg', 'rect', 'circle', 'path', 'text', 'title'])
const ATTRS = new Set([
  'viewBox', 'width', 'height', 'role', 'aria-label', 'font-family', 'x', 'y', 'rx', 'cx', 'cy', 'r', 'd', 'fill', 'fill-opacity',
  'fill-rule', 'stroke', 'stroke-width', 'stroke-linejoin', 'stroke-linecap', 'stroke-dasharray', 'font-size', 'font-weight',
  'text-anchor', 'transform',
])
const SAFE_VALUE = /^[#\w\s.,%()'"-]*$/

export function safeSvg(source: string): SVGSVGElement | null {
  const doc = new DOMParser().parseFromString(source, 'image/svg+xml')
  const root = doc.documentElement
  if (root.nodeName !== 'svg' || doc.querySelector('parsererror')) return null
  const ns = 'http://www.w3.org/2000/svg'
  const copy = (el: Element): Element | null => {
    if (!ELEMENTS.has(el.nodeName)) return null
    const out = document.createElementNS(ns, el.nodeName)
    for (const a of Array.from(el.attributes)) {
      const ok = a.name === 'aria-label' || (SAFE_VALUE.test(a.value) && !/url\s*\(/i.test(a.value))
      if (ATTRS.has(a.name) && ok) out.setAttribute(a.name, a.value)
    }
    for (const c of Array.from(el.childNodes)) {
      if (c.nodeType === Node.TEXT_NODE) out.appendChild(document.createTextNode(c.textContent ?? ''))
      else if (c.nodeType === Node.ELEMENT_NODE) {
        const k = copy(c as Element)
        if (k) out.appendChild(k)
      }
    }
    return out
  }
  return copy(root) as SVGSVGElement | null
}
